import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import { useGetAccountInfo } from '@/queries/account/useGetAccountInfo'
import { CoreLevelFeatureNames } from '@/services/types/permissions/permissionFeatures/mockCorePermissionFeature'
import { useCorePermissions } from '@/stores/permissions/permissions'
import { usePremiumFeaturesHasUpgrade } from '@/stores/permissions/premiumFeatures'
import { useMemo } from 'react'

export const useSelfServeAndPermissions = () => {
  const { accountId } = useCognitoAuth()
  const { data: accountInfo, isLoading: isAccountInfoLoading } = useGetAccountInfo({ accountId })
  const billingAndPaymentsPermission = useCorePermissions(CoreLevelFeatureNames.billingAndPayments)
  const upgradePackagePermission = useCorePermissions(CoreLevelFeatureNames.upgradePackage)
  const hasUpgrade = usePremiumFeaturesHasUpgrade()

  const showBillingAndPaymentsPage = useFlag(DashboardExperiments.billingAndPaymentsPage)
  const showUpgradePackagePage = useFlag(DashboardExperiments.upgradePackagePage)

  const shouldShowBillingAndPayments = useMemo(() => {
    const hasPermission = !!billingAndPaymentsPermission?.view
    return (
      showBillingAndPaymentsPage || (hasPermission && accountInfo?.accountType === 'SELF_SERVE')
    )
  }, [billingAndPaymentsPermission, showBillingAndPaymentsPage, accountInfo])

  const shouldShowUpgradePackagePage = useMemo(() => {
    const hasPermission = !!upgradePackagePermission?.view
    return (
      hasUpgrade &&
      (showUpgradePackagePage || (hasPermission && accountInfo?.accountType === 'SELF_SERVE'))
    )
  }, [hasUpgrade, upgradePackagePermission, showUpgradePackagePage, accountInfo])

  return { shouldShowBillingAndPayments, shouldShowUpgradePackagePage, isAccountInfoLoading }
}
